import { ColorModeScript } from "@chakra-ui/react";
import * as React from "react";
import ReactDOM from "react-dom";
import { App } from "./App";
import ReactGA from "react-ga4";
import "./index.css";
import "./assets/sport-icons.css";

export const IS_PROD =
  process.env.NODE_ENV !== "development" &&
  !window.location.href.includes("/test/");

if (IS_PROD) {
  ReactGA.initialize("G-DD637XHLJB");
  ReactGA.set({ anonymizeIp: true });
  ReactGA.send({ hitType: "pageview", page: "/" });
}

ReactDOM.render(
  <React.StrictMode>
    <ColorModeScript initialColorMode="light" />
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
